import React, { useState, useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./kcgheader.css";

const navitems = [
  { text: "About UTahdata.org", to: "/about" },
  { text: "Utah At a Glance", to: "/utah-at-a-glance" },
  { text: "Utah Verticals", to: "/verticals" },
  { text: "Contact Us", to: "/contact" },
];

const KcgHeader = ({ scrollContainerRef }) => {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleClick = () => navigate("/");
  const goto = useCallback(
    (to) => {
      navigate(to);
      setIsMenuOpen(false);
    },
    [navigate]
  );

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const scrollElement = scrollContainerRef?.current;
    if (!scrollElement) return;

    const onScroll = () => {
      setScrolled(scrollElement.scrollTop > 10); // Use scrollTop, not scrollY
    };

    scrollElement.addEventListener("scroll", onScroll);
    return () => scrollElement.removeEventListener("scroll", onScroll);
  }, [scrollContainerRef]);

  return (
    <div>
      <header className={`kcg-header ${scrolled ? "scrolled" : ""}`}>
        <a href="https://utahdata.org">
          <img
            src="/img/headerlogo.png"
            alt="Utah Data Logo"
            className="logo"
            // onClick={handleClick}
          />
        </a>
        <a href="https://gardner.utah.edu/">
          <img
            src="/img/kcgbetsy/kemcgorg.png"
            alt="Utah Data Logo"
            className="kemclogo"
          />
        </a>
        <div className="text-white optionallogo">&nbsp;</div>
      </header>
    </div>
  );
};

export default KcgHeader;
